// extracted by mini-css-extract-plugin
export default {"anouncementBar":"AnouncementBar_anouncementBar__WLCp-","anouncementBarText":"AnouncementBar_anouncementBarText__NDwze"};